import "./leaderboard.scss";
import { useState, useEffect } from "react";
import { getLeaderboard } from "../../services/score";
import { useAuth } from "../../services/auth";
import { useNavigate, Link } from "react-router-dom";
import Loader from "../../components/loader/loader";
import heads from "../../assets/heads.png";
import tails from "../../assets/tails.png";

const Leaderboard = () => {
    const [leaders, setLeaders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading) {
            getLeaderboard()
                .then((data) => {
                    setLeaders(data);
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.error("Leaderboard error:", err);
                    setError(true);
                    setIsLoading(false);
                });
        }
    }, [loading]);

    if (isLoading) {
        return (
            <section className="leaderboard-page">
                <Loader />
            </section>
        );
    }

    if (error) {
        return (
            <section className="leaderboard-page">
                <div className="leaderboard-header">
                    <h2>Leaderboard</h2>
                    <button className="back-btn" onClick={() => navigate("/")}>
                        Back
                    </button>
                </div>
                <div className="leaderboard-auth-prompt">
                    <p>
                        <Link to="/login">Sign in</Link> to view the leaderboard
                        and compete with other players.
                    </p>
                </div>
            </section>
        );
    }

    return (
        <section className="leaderboard-page">
            <div className="leaderboard-header">
                <h2>Leaderboard</h2>
                <button className="back-btn" onClick={() => navigate("/")}>
                    Back
                </button>
            </div>
            <div className="leaderboard-list">
                <div className="leaderboard-row leaderboard-row-header">
                    <span className="rank-col">#</span>
                    <span className="name-col">Player</span>
                    <span className="score-col">Best Streak</span>
                    <span className="side-col">Side</span>
                </div>
                {leaders.map((entry, index) => {
                    const isMe = user && entry.uid === user.uid;
                    return (
                        <div
                            key={entry.uid || index}
                            className={`leaderboard-row${isMe ? " is-me" : ""}`}
                        >
                            <span className="rank-col">{index + 1}</span>
                            <span className="name-col">
                                {entry.username || "Anonymous"}
                            </span>
                            <span className="score-col">{entry.highScore}</span>
                            <span className="side-col">
                                <img
                                    src={
                                        entry.highScoreStrikeType === "tails"
                                            ? tails
                                            : heads
                                    }
                                    alt={entry.highScoreStrikeType || "heads"}
                                />
                                <span className="side-label">
                                    {entry.highScoreStrikeType === "tails" ? "Tails" : "Heads"}
                                </span>
                            </span>
                        </div>
                    );
                })}
                {leaders.length === 0 && (
                    <div className="leaderboard-empty">
                        No scores yet. Be the first to flip!
                    </div>
                )}
            </div>
            {!user && (
                <div className="leaderboard-cta">
                    <p>
                        <Link to="/login">Sign in</Link> to save your streak and
                        appear on the leaderboard.
                    </p>
                </div>
            )}
        </section>
    );
};

export default Leaderboard;
